import { render, staticRenderFns } from "./LoginPartner.vue?vue&type=template&id=6ff56cfd&scoped=true&"
import script from "./LoginPartner.vue?vue&type=script&lang=js&"
export * from "./LoginPartner.vue?vue&type=script&lang=js&"
import style0 from "./LoginPartner.vue?vue&type=style&index=0&id=6ff56cfd&prod&scoped=true&lang=css&"
import style1 from "./LoginPartner.vue?vue&type=style&index=1&id=6ff56cfd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff56cfd",
  null
  
)

export default component.exports